import {Icon} from '@amana/ui';

const Logo = () => <Icon name="LogoLabel" size={201} height={41} />;

export default Logo;
